import React from "react";

function Porque() {
  return (
    <div className="row mb-5">
      <div className="col-sm">
        <img
          className="img-fluid border-0"
          src="images/undraw_decide_3iwx.svg"
          alt=""
        />
      </div>
      <div className="col-sm">
        <h2>¿Por qué elegirnos?</h2>
        <p>
          El futuro esta aqui, únete a TodosUnidos. Parte de nuestro objetivo es
          informar y orientar a nuestros usuarios sobre el uso de la tecnología,
          y estaremos siempre a la vanguardia informando sobre los avances de la
          misma.
        </p>
        <p>
          Nuestra comunidad esta soportada por la firma TU Sistemas y una
          comunidad cada día creciendo mas de desarrolladores independientes.
        </p>
      </div>
    </div>
  );
}

export default Porque;
